// extracted by mini-css-extract-plugin
module.exports = {"pagination":"pagination--1ohuS","simple":"simple--XqlGw"};